<template>
  <el-dialog class="manage" top="10vh" :visible="isShow" :show-close="false" :close-on-click-modal="false"
    @close="fCancalPopupShow" :appendToBody='true'>
    <div class=" x-flex x-row-between  x-p-l-5  x-font-14  x-bd-bottom-E">
      <div class='x-flex x-font-14  x-p-15'>{{ title }}</div>
      <div class="x-flex x-cur-poi x-w40 x-row-right x-p-r-15 x-h50" @click="fCancalPopupShow">
        <i class="el-icon-close x-font-14 x-p-2 " style=" color:#808080 ;"></i>
      </div>
    </div>
    <div class=" x-flex x-h100p" style="height: 500px;">
      <div class="x-w190 x-h100p x-bd-right x-bd-bottom x-p-l-20 " style="overflow-y: auto;">
        <div style="height:490px ;">
          <el-tree ref="tree" default-expand-all highlight-curren :props="treeProps" :data="treeData" node-key="cls_id"
            highlight-current :current-node-key='actCls' @node-click='fChgClsTree'
            :expand-on-click-node="false"></el-tree>
        </div>
      </div>
      <div class="x-flex-1 " style="overflow: hidden;">
        <div class=" x-w100p" style="height: 500px;">
          <div class="x-h50 x-flex x-p-r-20" v-if="showHead">
            <div class="x-p-l-40">
              <el-radio-group v-model="fzy_yn" size="small" class="radio-plain">
                <el-radio-button label="N">精准</el-radio-button>
                <el-radio-button label="Y">模糊</el-radio-button>
              </el-radio-group>
            </div>
            <div class=" x-m-r-10 x-flex-1 x-p-l-4" style="min-width: 260px;">
              <el-input placeholder="条码,品名,拼音码,自编码" v-model="qry_txt" size="small"
                @keydown.enter.native='page.now_page = 1; fChgClsTree("00")'>
                <el-button slot="append" icon="el-icon-search" class="x-search"
                  @click='page.now_page = 1; fChgClsTree("00")'>查询
                </el-button>
              </el-input>
            </div>

            <x-button size="small" @click.native='fAddTableData'>确认新增</x-button>
          </div>
          <div :style="!showHead ? 'height: 100%;' : 'height: calc(100% - 50px);'" class="x-p-l-4 x-p-r-4">
            <vxe-table :border="true" stripe height='auto' ref="xTable" :data="tableManage" align="center"
              :checkbox-config="{ checkMethod: checCheckboxkMethod, reserve: true }"
              :row-config="{ isCurrent: true, isHover: true, keyField: 'cls_id' }" row-id="cls_id"
              @checkbox-change="fChecked" @checkbox-all="fChecked" @cell-dblclick="fDobClick">
              <vxe-column v-if="from == 'vip-md' || from == 'kq-pro' || from == 'kq-pp' || from == 'vip-md-online'"
                type="checkbox" width="60">
              </vxe-column>
              <vxe-column v-for="(item) in tableDataManageA" :key="item.RC" :field="item.field" :title="item.title"
                :min-width="item.width" sortable></vxe-column>
              <vxe-column title="操作" fixed="right" width="70"
                v-if="from != 'vip-md' && from != 'kq-pro' && from != 'kq-pp' && from != 'fp-mall' && from != 'vip-md-online'">
                <template slot-scope="scope">
                  <div class="x-cur-poi c-cz" @click="fEditCls(scope.row, 'EDIT')">编辑</div>
                </template>
              </vxe-column>
            </vxe-table>
          </div>
        </div>
        <!-- 页 -->
      </div>
    </div>
    <div>

      <div class="x-p-r-10 x-p-l-10 x-flex x-row-between x-h50">
        <div class=" x-bd-right x-w180 x-h100p x-flex x-row-left x-p-l-10" v-if="showzc_yn">
          <el-checkbox v-model="zc_ynCls"></el-checkbox>
          <span class="x-p-l-5">非正常</span>
        </div>
        <div class="x-lh-32 x-flex x-flex-1 x-row-between x-p-l-10" v-if="showPagination">
          <div>当前选中：{{ actClsName }}</div>
          <!-- 共{{TR}}条 <el-pagination background @current-change="" :page-size="page.page_size" layout="prev, pager, next"
            :total="TR" @current-change="fCurrentChange"> </el-pagination> -->
        </div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
export default {
  props: {
    //来源
    from: {
      type: [String, Boolean],
      default: false,
    },
    // 是否显示
    isShow: {
      type: [String, Boolean],
      default: false,
    },
    // 是否显示
    priceWay: {
      type: [String, Boolean],
      default: false,
    },
    //所属分类列表
    treeData: [Array, Object],
    default: () => {
      return []
    },
    //已经选中的JSON
    json: [Array, Object],
    default: () => {
      return []
    },
    proId: {
      type: [String, Boolean],
      default: '',
    },
  },
  data() {
    return {
      showHead: false,
      showPagination: true,
      showzc_yn: true,
      fzy_yn: 'Y',
      qry_txt: '',
      actCls: '',
      actClsName: '',
      title: '分类管理',
      zc_ynCls: false,
      treeProps: {
        "label": "cls_name",
        "value": 'cls_id'
      },
      clsData: {},
      tableManage: [],
      //表
      tableDataManageA: [

        {
          field: "cls_id",
          title: "编码",
          width: "100px",
        },
        {
          field: "cls_name",
          title: "名称",
          width: "100px",
        },
        {
          field: "state_lng",
          title: "状态",
          width: "100px",
        },
        {
          field: "chg_user_name",
          title: "修改员工",
          width: "100px",
        }
      ],
      //门店表
      tableDataManageC: [

        {
          field: "mall_id",
          title: "编码",
          width: "100px",
        },
        {
          field: "mall_name",
          title: "名称",
          width: "100px",
        },
        {
          field: "state",
          title: "状态",
          width: "100px",
        },
        {
          field: "chg_user_name",
          title: "修改员工",
          width: "100px",
        }
      ],
      //商品表
      tableDataManageB: [{
        field: "unit",
        title: "单位",
        width: "100px",
      }, {
        field: "pf_price",
        title: "零售价",
        width: "100px",
      }, {
        field: "vip_price",
        title: "会员价",
        width: "100px",
      }, {
        field: "price_way",
        title: "计价方式",
        width: "100px",
      }, {
        field: "pro_type",
        title: "商品类型",
        width: "100px",
      }, {
        field: "cls_name",
        title: "所属分类",
        width: "100px",
      },],
      //供应商
      tableDataManageD: [{
        field: "gys_id",
        title: "编码",
        width: "130px",
      }, {
        field: "gys_name",
        title: "名称",
        width: "120px",
      }, {
        field: "wl_money",
        title: "应付款",
        width: "90px",
      }, {
        field: "mall_name",
        title: "所属门店",
        width: "100px",
      }, {
        field: "price_way",
        title: "采购价格",
        width: "100px",
      }, {
        field: " cp_name",
        title: "联系人",
        width: "90px",
      }, {
        field: "phone",
        title: "手机",
        width: "120px",
      }, {
        field: "chg_user_name",
        title: "修改员工",
        width: "100px",
      }, {
        field: "chg_time",
        title: "修改时间",
        width: "160px",
      }],
      //线上商城选择商品
      tableDataManageE: [{
        field: "pro_id",
        title: "条码",
        width: "140px",
      },
      {
        field: "pro_name",
        title: "名称",
        width: "140px",
      },
      {
        field: "unit",
        title: "单位",
        width: "90px",
      },
      {
        field: "stock",
        title: "库存",
        width: "90px",
      },
      {
        field: "sale_price",
        title: "售价",
        width: "90px",
      }

      ],
      //页
      TP: 0,
      TR: 0,
      page: {
        page_size: 50,
        now_page: 1
      },
      bigCls: {},
      //临时数组
      checkList: [],
      // selectedPapers: new Set() // 选中数据
    }
  },
  created() {
    if (this.from == 'commodity') {
      this.title = '商品分类'
    }


  },
  watch: {
    zc_ynCls(newVal) {
      if (this.from == 'kq-cls') {
        this.fClickAll()
        return
      }
      this.fChgClsTree(this.bigCls)
    },
    isShow(newVal) {
      if (newVal) {
        this.bigCls = this.findClsById('1001')

        if (this.from == 'kq-cls') {
          setTimeout(() => {
            this.fClickAll()
          }, 100)
          return
        }
        this.fChgClsTree(this.bigCls)
      }
    },
    treeData: {
      handler(newVal, oldVal) {
        this.bigCls = this.findClsById('1001')
        this.fChgClsTree({
          cls_id: this.actCls || '1001'
        })
      },
      immediate: false, // 立即执行一次监听器
      deep: true // 深度监听

    }
  },
  methods: {
    findClsById(clsId) {
      return this.treeData.find(item => item.cls_id === clsId);
    },
    //选中内分类树
    async fChgClsTree(data) {
      this.clsData = data
      let res = null;
      let js = {
        oper: 'CLS_LIST',
        mall_id: this.$store.state.djsAdmin.mall_id,
        cls_id: data.cls_id,
        state_id: this.zc_ynCls ? 'sipSc' : 'sipZc',
        top_yn: 'Y'
      }
      if (this.from == 'dish') {
        res = await this.api.smCommon.GET_PRO_CLS_INFO(js)
      }
      if (this.from == 'feed') {
        res = await this.api.smCommon.GET_FEED_CLS_INFO(js)
      }
      if (this.from == 'flav') {
        res = await this.api.smCommon.GET_FLAV_CLS_INFO(js)
      }
      if (this.from == 'mall') {
        res = await this.api.smCommon.GET_MALL_CLS_INFO(js)
      }
      if (this.from == 'table') {
        res = await this.api.smCommon.GET_DTABLE_CLS_INFO(js)
      }
      if (this.from == 'user' || this.from == 'fp-mall') {
        res = await this.api.smCommon.GET_USER_CLS_INFO(js)
      }
      if (this.from == 'vip') {
        res = await this.api.smCommon.GET_VIP_CLS_INFO(js)
      }
      if (res.result != 'sucess') {
        return this.$message.error(res.msg)
      }
      this.tableManage = res.data

      // if (data.cls_id == '1001') {
      //   this.actCls = res.data[0].cls_id
      //   this.actClsName = res.data[0].cls_name
      // } else {
      this.actCls = data.cls_id
      this.actClsName = data.cls_name
      // }


      this.fShowCheak(this.checkList)
      if (res.data.length > 0) {
        this.TP = Number(res.data[0].TP)
        this.TR = Number(res.data[0].TR)
      } else {
        this.TP = 0
        this.TR = 0
      }
    },
    //操作商品分类
    async fEditCls(data, oper) {
      if (data.cls_id.length == 4) {
        return this.$message.error('最大分类暂不允许修改')
      }
      if (this.from == 'kq-cls') {
        let res = await this.api.smCommon.fGetClsInfo('KQ', 'CLS_ID', data.cls_id, this.zc_ynCls)
        if (res.result != 'sucess') {
          return this.$message.error(res.msg)
        }
        let kqClsInfo = res
        this.$emit('fChgCls', kqClsInfo)
        return
      }
      this.$emit('fChgCls', data, 'EDIT')
    },
    //禁用
    checCheckboxkMethod({
      row
    }) {
      return row.cls_id.length > 2
    },
    //新增VIP弹窗内门店数据
    fAddTableData() {
      // this.fChecked()
      // let res = this.$refs.xTable.getCheckboxRecords(true)
      if (this.checkList.length < 1) {
        return this.$message.error('请勾选数据')
      }
      this.$emit("fAddTableData", this.checkList);
    },
    fDobClick(e) {
      if (e.row.cls_id.length > 4) {
        this.$emit("fDobClick", e.row);
      } else {
        if (this.from == 'fp-mall') {
          return this.$message.error('请选择其他角色')
        }
        return this.$message.error('请选择其他分类')
      }
    },
    //卡券分类
    //点击全部
    async fClickAll() {
      this.$refs.tree.setCurrentKey(null);
      this.actCls = '1001'
      this.actClsName = '全部卡券'
      let res = await this.api.smCommon.fGetClsInfo('KQ', 'CLS_LIST', '', this.zc_ynCls)
      if (res.result != 'sucess') {
        return this.$message.error(res.msg)
      }
      this.tableManage = res.data
      if (res.data.length > 0) {
        this.TP = res.data[0].TP
        this.RC = res.data.length
      }
    },
    //分页
    async fCurrentChange(e) {
      // this.fChecked()
      this.page.now_page = e;
      this.fChgClsTree(this.clsData)
    },
    //关闭弹窗
    fCancalPopupShow() {
      this.checkList = []
      this.$emit("close");
    },

    //复选框回显
    fShowCheak(json) {
      this.checkList = json || this.json
      // 复选框回显
      let rowId = ''
      let check = false
      switch (this.from) {
        case 'vip-md':
          rowId = 'mall_id'
          check = true
          break
        case 'kq-pro-detail':
        case 'online-pro-detail':
          rowId = 'pro_id'
          check = true
          break
        case 'kq-pp':
        case 'kq-pro':
          rowId = 'cls_id'
          check = true
          break
      }

      if (check) {
        this.$refs.xTable.setAllCheckboxRow(false)
        this.checkList.forEach(item1 => {
          this.tableManage.forEach(async (item, index) => {
            if (item[rowId] == item1[rowId]) {
              let row = await this.$refs.xTable.getRowById(item[rowId])
              await this.$refs.xTable.setCheckboxRow(this.$refs.xTable.getRowById(item[rowId]), true)
            }
          })
        })
      }
    },
    // 选中
    fChecked(obj) {
      let rowId = ''
      let check = false
      switch (this.from) {
        case 'vip-md':
          rowId = 'mall_id'
          check = true
          break
        case 'kq-pro-detail':
        case 'online-pro-detail':
          rowId = 'pro_id'
          check = true
          break
        case 'kq-pp':
        case 'kq-pro':
          rowId = 'cls_id'
          check = true
          break
      }
      //如果obj没有data为全选
      if (this.api.smCom.fSmIsEmpty(obj.data)) {
        if (obj.checked) {
          this.checkList = this.checkList.concat(this.tableManage)
          this.checkList = this.api.smCom.uniqueArray(this.checkList, rowId)
        } else {
          let arr = []
          this.checkList.forEach((item, index) => {
            let idx = this.tableManage.findIndex(tableManageItem => {
              return item[rowId] == tableManageItem[rowId]
            })
            if (idx == -1) {
              arr.push(item)
              return
            }
          })
          this.checkList = this.api.smCom.uniqueArray(arr, rowId)
        }
        //去空
        //否则为单选
      } else {
        if (obj.checked) {
          this.checkList = this.checkList.concat(obj.row)
          this.checkList = this.api.smCom.uniqueArray(this.checkList, rowId)
        } else {
          this.checkList.forEach((item, index) => {
            if (item[rowId] == obj.row[rowId]) {
              this.checkList.splice(index, 1)
            }
          })
        }
      }
      // let res = this.$refs.xTable.getCheckboxRecords(true)
      // if (!this.api.smCom.fSmIsEmpty(res)) {
      //   this.checkList = this.checkList.concat(res)
      //   this.checkList = this.api.smCom.uniqueArray(this.checkList, rowId)
      // }
    },

    // 请求===========================
    // 获取卡券列表
    async fGetKqInfo(oper, clsId) {
      let js = {};
      js['OPER'] = oper;
      // js['MALL_ID'] = this.gSh.mallId;
      js['CLS_ID'] = clsId || '1001';
      js['SEARCH_STR'] = this.qry_txt;
      js['PAGE_SIZE'] = this.page.page_size;
      js['NOW_PAGE'] = this.page.now_page;
      js['ZC_YN'] = this.zc_ynCls ? "N" : "Y";
      js['MH_YN'] = this.fzy_yn ? "Y" : "N";

      let res = await this.api.smSellApi.fPostToSmSellQueryApi('GET_KQ_INFO', js)

      return res;
    },
    //
    async fGetWgoProClsData(oper, clsId,) {
      let js = {};
      js['OPER'] = oper;
      js['MALL_ID'] = this.$store.state.smElabelAdmin.shMallId;
      js['CLS_ID'] = clsId || '1001';
      js['ZC_YN'] = this.zc_ynCls ? "N" : "Y"
      let res = await this.api.smSellApi.fPostToSmSellWgoApi('GET_WGO_PRO_CLS_DATA', js)
      return res;
    },
    async fGetWgoProInfo(obj) {
      let js = {};
      js['OPER'] = obj.oper;
      js['MALL_ID'] = obj.mallId || this.$store.state.smElabelAdmin.shMallId;
      js['CLS_ID'] = obj.clsId || '1001';
      js['GYS_ID'] = obj.gys_id || '';
      js['PP_ID'] = obj.pp_id || '';
      js['SEARCH_STR'] = obj.qry_txt;
      js['PAGE_SIZE'] = obj.page_size || '50';
      js['NOW_PAGE'] = obj.now_page || '1';
      js['ZC_YN'] = obj.zc_yn ? "N" : "Y";
      js['MH_YN'] = obj.fzy_yn ? "Y" : "N";
      js['ORDER_BY'] = obj.orderBy
      js['PRO_TYPE'] = obj.proType || ''
      js['PRICE_WAY'] = obj.priceWay
      js['ONLINE_STATE'] = '已上架'
      js['PRO_GLTJ_MAIN_PRO_ID'] = this.proId
      let res = await this.api.smSellApi.fPostToSmSellWgoApi(' GET_WGO_PRO_INFO', js)
      return res;
    },
  }
}
</script>

<style scoped="scoped" lang="less">
/deep/.el-dialog {
  width: 800px;
  height: 600px;
}

/deep/.vxe-table--render-default .vxe-cell {
  white-space: unset;
}

//新增嵌套多出来的头部
/deep/.el-dialog__header {
  display: none;
}

//新增嵌套多出来的内边距
/deep/.el-dialog__body {
  padding: 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/cls_manage.vue